import Immutable from 'immutable';
import * as types from './AdminUsers.types';

const initialState = {
    type: null,
    users: [],
    fetching: false,
    saving: false,
    idModal: null,
    pagination: {
        totalElements: 0,
        activePage: 1,
        totalPages: 0,
        elementsPerPage: 15,
    },
    fields: {},
    isDeleting: false,
    sort: {
        column: 'name',
        type: 'asc',
    },
    search: '',
    searchType: 'name',
    permissions: [],
}

export default function (state = initialState, action) {
    state = Immutable.fromJS(state);
    switch (action.type) {
        case types.FETCH_USERS:
            return state.setIn(['fetching'], true).toJS();

        case types.FETCH_USERS_SUCCESS:
            return state.setIn(['fetching'], false)
                .setIn(['users'], action.payload.elements)
                .setIn(['pagination', 'totalElements'], action.payload.totalElements)
                .setIn(['pagination', 'activePage'], action.payload.activePage)
                .setIn(['pagination', 'totalPages'], action.payload.totalPages)
                .setIn(['pagination', 'elementsPerPage'], action.payload.elementsPerPage)
                .toJS();

        case types.FETCH_USERS_ERROR:
            return state.setIn(['fetching'], false).toJS();

        case types.SAVE_USER:
            return state.setIn(['saving'], true).toJS();

        case types.SAVE_USER_SUCCESS:
            return state.setIn(['saving'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.SAVE_USER_ERROR:
            return state.setIn(['saving'], false).toJS();

        case types.DELETE_USER:
            return state.setIn(['isDeleting'], true).toJS();

        case types.DELETE_USER_SUCCESS:
            return state.setIn(['isDeleting'], false)
                .setIn(['idModal'], null)
                .toJS();

        case types.DELETE_USER_ERROR:
            return state.setIn(['isDeleting'], false).toJS();

        case types.SET_ID_MODAL:
            return state.setIn(['idModal'], action.payload).toJS();

        case types.SET_ACTIVE_PAGE:
            return state.setIn(['pagination', 'activePage'], action.payload).toJS();

        case types.SET_FIELD:
            return state.setIn(['fields', action.payload.field], action.payload.value).toJS();

        case types.SET_SORT:
            return state.setIn(['sort', 'type'], action.payload.type)
                .setIn(['sort', 'column'], action.payload.column)
                .toJS();

        case types.SET_SEARCH:
            return state.setIn(['search'], action.payload).toJS();

        case types.SET_SEARCH_TYPE:
            return state.setIn(['searchType'], action.payload).toJS();

        case types.SET_FIELDS:
            return state.setIn(['fields'], action.payload).toJS();

        case types.SET_PERMISSIONS:
            return state.setIn(['permissions'], JSON.parse(action.payload)).toJS();

        case types.ADD_PERMISSION:
            return state.updateIn(['permissions'], (permissions) => {
                return permissions.push(action.payload);
            }).toJS();

        case types.REMOVE_PERMISSION:
            return state.updateIn(['permissions'], (permissions) => {
                const index = permissions.indexOf(action.payload);
                return permissions.delete(index);
            }).toJS();

        case types.RESET_STATE:
            return initialState;

        default:
            return state.toJS();
    }
}